import { render, staticRenderFns } from "./recycleList.vue?vue&type=template&id=220dd317&scoped=true&"
import script from "./recycleList.vue?vue&type=script&lang=js&"
export * from "./recycleList.vue?vue&type=script&lang=js&"
import style0 from "./recycleList.vue?vue&type=style&index=0&id=220dd317&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220dd317",
  null
  
)

export default component.exports